<template>
  <section class="modules-wrap">
    <!-- table start -->
    <el-table
      :data="tableData"
      height="100%"
      :border="true"
      :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
    >
      <el-table-column type="index" align="center" width="100" label="序号">
      </el-table-column>
      <el-table-column
        prop="supplier_name"
        align="center"
        label="供货商"
        min-width="150"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="statistics_time"
        align="center"
        label="时间段"
        min-width="150"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="number"
        align="center"
        label="销售件数"
      ></el-table-column>
      <el-table-column prop="aftersale_total" align="center" label="售后件数">
      </el-table-column>
      <el-table-column
        prop="aftersale_proportion"
        align="center"
        label="售后占比"
      ></el-table-column>
      <el-table-column
        prop="flattenedProducts"
        align="center"
        label="售后排名前三"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.flattenedProducts || "-" }}</span>
        </template></el-table-column
      >

      <!-- <el-table-column
        label="操作"
        min-width="150"
        align="center"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button type="text" @click="onHandleEditData(scope.row)"
            >编辑</el-button
          >
          <el-button type="text" @click="onHandleDetail(scope.row)"
            >查看</el-button
          >
        </template>
      </el-table-column> -->
    </el-table>
    <!-- table end -->
  </section>
</template>

<script>
export default {
  name: "TableList",
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  methods: {
    /**
     * 编辑
     */
    onHandleEditData(row) {},
    /**
     * 详情
     */
    onHandleDetail(row) {
      const query = {
        id: row.id,
      };
      this.$router.push({
        path: "/data-detail",
        query,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.modules-wrap {
  flex: 1;
  overflow: hidden;
  .table {
    height: calc(100% - 20px);
  }
}
</style>
